import React from "react";
import {
  IconApple,
  IconNotVerified,
  IconVerified,
} from "../../components/icons";
import { Form, Button, Input } from "antd";
import { unverifyApple, verifyApple } from "../../api";
import { useTranslation } from "react-i18next";
import { commonUtil } from "../../utils";

interface Props {
  reload: Function;
  identifier: any;
  canUnlink: boolean;
}

const UpdateApple: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation(["common", "notification"]);
  const onClickLinkApple = async () => {
    const data = await window.AppleID.auth.signIn();
    const res = await verifyApple({ idToken: data.authorization.id_token });
    if (res.status === "error") {
      commonUtil.showMessage("error", res.message);
      return;
    }
    commonUtil.showMessage("success", t("notification:Liên kết thành công"));
    props.reload();
  };

  const onClickRemoveApple = async () => {
    const res = await unverifyApple();
    if (res.status === "error") {
      commonUtil.showMessage("error", res.message);
      return;
    }
    commonUtil.showMessage(
      "success",
      t("notification:Hủy liên kết thành công")
    );
    props.reload();
  };

  return (
    <Form.Item
      label={
        <div className="flex items-center gap-4">
          Apple
          {props.identifier && props.identifier.status === "verified" ? (
            <IconVerified />
          ) : (
            <IconNotVerified />
          )}
        </div>
      }
    >
      {props.identifier ? (
        <Input
          disabled={true}
          style={{ backgroundColor: "white", color: "black" }}
          prefix={
            <>
              <IconApple width={20} height={20} />
              &nbsp;&nbsp;
              <span>
                {props.identifier.metadata?.email || "Đã liên kết Apple"}
              </span>
            </>
          }
          suffix={
            props.identifier && props.canUnlink ? (
              <span
                style={{ color: "#F5222D", cursor: "pointer" }}
                onClick={(e) => onClickRemoveApple()}
              >
                {t("common:Bỏ kết nối")}
              </span>
            ) : null
          }
        />
      ) : (
        <Button
          block={true}
          onClick={() => onClickLinkApple()}
          className="!border-red-primary !px-16 !py-8 h-auto"
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconApple width={20} height={20} />
            &nbsp;&nbsp;
            <span style={{ color: "#40a9ff" }}>
              {t("common:Liên kết tài khoản Apple")}
            </span>
          </div>
        </Button>
      )}
    </Form.Item>
  );
};

export default UpdateApple;
